import { render, staticRenderFns } from "./FishAllSkillsComponent.vue?vue&type=template&id=8bf03a0a&"
import script from "./FishAllSkillsComponent.vue?vue&type=script&lang=ts&"
export * from "./FishAllSkillsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports